import { render } from "./Footer.vue?vue&type=template&id=6404aa5b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6404aa5b&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6404aa5b"]])

export default __exports__